<style>
@keyframes shake {
  0% { transform: translate(1px, 1px) rotate(0deg); }
  10% { transform: translate(-1px, -2px) rotate(-1deg); }
  20% { transform: translate(-3px, 0px) rotate(1deg); }
  30% { transform: translate(3px, 2px) rotate(0deg); }
  40% { transform: translate(1px, -1px) rotate(1deg); }
  50% { transform: translate(-1px, 2px) rotate(-1deg); }
  60% { transform: translate(-3px, 1px) rotate(0deg); }
  70% { transform: translate(3px, 1px) rotate(-1deg); }
  80% { transform: translate(-1px, -1px) rotate(1deg); }
  90% { transform: translate(1px, 2px) rotate(0deg); }
  100% { transform: translate(1px, -2px) rotate(-1deg); }
}
.shacke-class{
  animation-iteration-count: infinite;
}

.selectedevent {
    width:10rem;
    -webkit-transition: width 1s; 
    transition: width 1s;
}
.noselectedevent {
    width:4rem;
    -webkit-transition: width 1s; 
    transition: width 1s;
}
</style>

<template>
  <div style="width:100%">
    <v-container >
        <v-form 
            ref="form"
            v-model="validForm"
            lazy-validation
        >
        <v-layout row wrap align-center>
            <v-flex xs12 sm12 md12>
                <v-combobox
                    v-model="selectedGateway"
                    label="Select gateway"
                    :items="gateways"
                    item-value="id"
                    item-text="attributes.customName"
                    solo
                    chips
                    return-object
                    :rules="selectedGatewayRules"
                    required
                >
                <template v-slot:selection="data">
                    <v-chip
                    :key="JSON.stringify(data.item)"
                    :selected="data.selected"
                    :disabled="data.disabled"
                    class="v-chip--select-multi"
                    @input="data.parent.selectItem(data.item)"
                    >
                    <v-avatar
                        class="accent" 
                    ><v-icon color="#EEEEEE" dark>router</v-icon></v-avatar>
                    {{ data.item.attributes.customName }}
                    </v-chip>
                </template>
                </v-combobox>
            </v-flex>
        </v-layout>
        <v-layout row wrap elevation-1 white align-center>
            <v-container>
                <v-layout  row wrap justify-space-around align-center>
                    <v-flex xs12 sm8 md9>
                        <v-select
                            prepend-icon="memory"
                            :items="devices"
                            item-value="id"
                            item-text="attributes.customName"                      
                            label="Select device"
                            v-model="selectedDevice"
                            return-object
                            :rules="selectedDeviceAvailableRules"
                            required
                        ></v-select>
                    </v-flex>
                    <v-flex xs12 sm1 md1>
                        <v-btn class="white" icon  v-on:click="fetchSlaveDevices()">
                            <v-icon color="blue">sync</v-icon>
                        </v-btn>
                    </v-flex>
                    <v-spacer></v-spacer>
                     <v-flex>
                        <v-btn class="blue" icon dark v-on:click="submit">
                            <v-icon>play_arrow</v-icon>
                        </v-btn>
                    </v-flex>            
                </v-layout>
            </v-container>
        </v-layout>
        </v-form>
        <v-layout row wrap align-center white elevation-1 style="margin-top:2rem;padding:1rem;">
            
            <v-layout justify-space-between v-if="selectedDevice==null">
                <v-flex 
                    xs12 sm4 md3
                    v-for="i in [1,2,4,5]" 
                    :key="i"
                >
                    <v-avatar 
                        color="#E0E0E0"
                        size="5rem"
                    >
                    </v-avatar>
                </v-flex>
            </v-layout>

            <div  v-if="selectedDevice!=null" style="width:100%"> 
                <v-card
                    :class="'mx-auto lighten-5 text-capitalize '+colors[index%colors.length]"
                    v-for="(events,index) in supportedAiEvents"
                    :key="index"
                >
                    <v-card-title  style="color:white;padding:0.3rem;padding-left:0.6rem;margin-bottom:0.5rem" :class="colors[index%colors.length]">
                    <span class=" font-weight-medium"><v-icon dark small>{{events.icon}}</v-icon> {{events.title}}</span>
                    </v-card-title>

                    <v-layout justify-space-between
                        style="margin:1rem"
                        row wrap
                    >

                        <v-flex 
                            xs4 sm3 md2
                            v-for="(aiEventType,index) in events.items" 
                            :key="index"
                        >
                            <v-layout row wrap>
                                <v-flex xs12>
                                    <img 
                                        v-bind:class="{
                                            //selectedevent: (lastEventTypes.find(lastEvent => lastEvent.aiEvent==aiEventType.id&&lastEvent.aiDomain==aiEventType.type))?true:false, 
                                            //noselectedevent: (!lastEventTypes.find(lastEvent => lastEvent.aiEvent==aiEventType.id&&lastEvent.aiDomain==aiEventType.type))?true:false,
                                            'shacke-class':(lastEventTypes[aiEventType.type])?((lastEventTypes[aiEventType.type].aiEvent==aiEventType.id)?true:false):false, 
                                            selectedevent: (lastEventTypes[aiEventType.type])?((lastEventTypes[aiEventType.type].aiEvent==aiEventType.id)?true:false):false, 
                                            noselectedevent: (!lastEventTypes[aiEventType.type])?true:((!(lastEventTypes[aiEventType.type].aiEvent==aiEventType.id))?true:false),
                                        }"  
                                        :src="aiEventType.img"
                                    />
                                </v-flex>
                                <v-flex xs12>
                                    <span class="caption">{{aiEventType.id[0].toUpperCase()+aiEventType.id.slice(1)}}</span>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                    </v-layout>
                </v-card>
            </div>
        </v-layout>
        <v-layout row wrap align-center white elevation-1 style="margin-top:2rem;padding:1rem;">
            <v-data-table
                :headers="headers"
                :items="enrichedEvents"
                :custom-sort="(items)=>items.sort((a,b)=>b.timestamp-a.timestamp)"
                :loading="aiRealtime"
                class="elevation-1"
                style="width:100%"
            >
                <v-progress-linear 
                    v-slot:progress 
                    indeterminate
                ></v-progress-linear>
                <template v-slot:items="props">
                <td>
                    <img 
                        style="width:2rem"
                        :src="props.item.img"
                    />
                </td>
                <td class="text-xs-left">{{ props.item.name }}</td>
                <td class="text-xs-left">{{ props.item.timestamp }}</td>
                </template>
            </v-data-table>
        </v-layout>
    </v-container>

    <v-snackbar
        :timeout="0"
        :value="aiRealtime"
        :bottom="true"
        :right="true"
    >
        <v-progress-circular
            width="1.7"
            style="width:1.2rem;"
            indeterminate
            color="green"
        ></v-progress-circular>
      <span style="font-weight:bold">Listening AI events</span>
        <v-btn icon dark v-on:click="stopRealtimeEvents">
            <v-icon>pause</v-icon>
        </v-btn>
    </v-snackbar>

    <inprogress  :dialog="operationInProcess" :message="operationInProcessMessage" ></inprogress>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { setTimeout } from 'timers'
import Vue from 'vue'


    export default {

        name: "AI",
        
        data: function(){
            return {
                colors:["teal","purple","yellow","red","blue"],
                validForm: false,
                selectedDeviceAvailableRules:[
                    v => !!v || 'Device required'
                ],
                selectedGatewayRules:[
                    v=> !!v || 'Select a gateway'
                ],
                selectedGateway : null,
                selectedDevice: null,
                lastEvent: null,
                lastEventTypes:[],
                headers: [
                    { text: '', value: 'img',align:'left' },
                    { text: 'Event', alue: 'aiEvent'},
                    { text: 'Date/Time', value: 'timestamp' ,sortable: false,}
                ]
            }
        },

        computed:{
            ...mapState(
                {
                    aiMetadata: state => state.metadata.models.data.measures.ai,
                    aiDevices: state => 
                        state
                        .devices
                        .devices
                        .filter(
                            device => 
                                device.configurationSignaled.aiEvents!=null &&
                                device.configurationSignaled.aiEvents!=undefined
                        ),
                    gateways: state => 
                        state
                        .devices
                        .devices
                        .filter(device => device.attributes.isGateway == true),
                    events: state => state.telemetry.aiEvents,
                    aiRealtime: state => state.telemetry.listeningAIRealtime,
                    operationInProcess:'operationInProcess',
                    operationInProcessMessage: 'operationInProcessMessage'
                }
            ),
            
            
            supportedAiEvents(){
                if(!this.selectedDevice)
                    return null
                let map = []
                let result = []
                this
                    .selectedDevice
                    .configurationSignaled
                    .aiEvents
                    .forEach((event)=>{
                        if(!map[event.type])
                           map[event.type]=[]
                        map[event.type].push(event) 
                    })
                    
                for(let index in map){
                    
                    let metadata = this.aiMetadata.algorithms.find(a=>a.name.toLowerCase()==index.toLowerCase())
                    
                    result.push({title:index,items:map[index],icon:(metadata)?metadata.icon:undefined})
                }
                return result
            },

            devices: function(){
                return this.selectedGateway?
                        this.aiDevices
                            .filter(
                                device => 
                                    device.attributes.gateway == this.selectedGateway.id ||
                                    device.attributes.proxyGateway == this.selectedGateway.id 
                            ) :
                        []
            },


            enrichedEvents: function(){
                if(!this.selectedDevice)
                    return []
                return this
                        .events.filter(
                            event=>
                                event.deviceId == this.selectedDevice.id &&
                                event.gateway == this.selectedDevice.attributes.gateway
                        )
                        .map(
                            event =>
                            { 
                                let eventModel = this.selectedDevice
                                            .configurationSignaled
                                            .aiEvents
                                            .find(aiEventType=>event.aiEvent==aiEventType.id)                                
                                return {
                                    name:event.aiEvent,
                                    timestamp:new Date(event.timestamp),
                                    img: (eventModel)?eventModel.img:""
                                }
                            }
                        )
            }
        },


        watch:{

            selectedGateway:function(newG,oldG){
                if(!newG||!oldG){
                    this.selectedDevice=null
                    return
                }
                if(newG.id!=oldG.id)
                    this.selectedDevice=null

            },

            events:{
                deep:true,
                handler:function(){
                    if(!this.selectedDevice)
                        return

                    let selectedEvents = 
                        this
                            .events
                            .filter(
                                event=>
                                    event.deviceId == this.selectedDevice.id &&
                                    event.gateway == this.selectedDevice.attributes.gateway
                            )
                    setTimeout(
                        ()=>{    
                            for(let i in selectedEvents) {
                                let key = selectedEvents[i].aiDomain.toLowerCase()
                                Vue.set(this.lastEventTypes,key,selectedEvents[i])
                            }

                            this.lastEvent = (selectedEvents.length>0)?
                                selectedEvents[selectedEvents.length-1]:
                                null
                            
                        },
                        500
                    )                    
                }
            }
        },

        async destroyed(){
            await 
                this
                .$store
                .dispatch('telemetry/stopAIRealtime')
        },

        methods:{
            submit: async function(){
                this.validForm = this.$refs.form.validate()
                if (this.validForm) 
                {
                    await 
                        this
                        .$store
                        .dispatch('telemetry/stopAIRealtime')
                    await 
                        this
                        .$store
                        .dispatch('telemetry/startAIRealtime',this.selectedDevice)                    
                }
            },

            stopRealtimeEvents: async function(){
                await 
                    this
                    .$store
                    .dispatch('telemetry/stopAIRealtime')
            },

            fetchSlaveDevices: function(){
                if(this.selectedGateway)
                    this.$store.dispatch("devices/fetchDevices",this.selectedGateway)
            },

        }
    }
</script>